// extracted by mini-css-extract-plugin
module.exports = {"PostDetailRight__searchPanel":"qe_a bhe_rq bhe_kr bhe_ks","PostDetailRight__brandDaysPosts":"qe_b bhe_rq bhe_kr bhe_ks"};